import { createReducer } from "reduxsauce";

import ReducerRegister from "../../../ReducerRegister";
import EditService from "../../../../services/screens/admin/section/EditService";
import { ActionTypes } from "../../../actionTypes/screens/admin/section/EditActionTypes";
import AsyncActionReducers from "../../../AsyncActionReducers";

import UIDs from "../../../../UIDs";

const uid = UIDs.screens.admin.readingbook.editsection;

//
// Actions
//
const Actions = {
    loadScreenViewAsync: id => {
        return (dispatch /*, getState*/) => {
            dispatch({ type: ActionTypes.LOAD_SCREEN_VIEW_ASYNC, id });

            EditService.loadScreenView(
                id,
                response => {
                    dispatch(Actions.loadScreenViewSuccess(response));
                },
                error => {
                    dispatch(Actions.loadScreenViewFailure(error));
                }
            );
        };
    },

    loadScreenViewSuccess: data => ({
        type: ActionTypes.LOAD_SCREEN_VIEW_SUCCESS,
        parentType: ActionTypes.LOAD_SCREEN_VIEW_ASYNC,
        postReducer: loadScreenViewSuccessPostReducer,
        data
    }),

    loadScreenViewFailure: error => ({
        type: ActionTypes.LOAD_SCREEN_VIEW_FAILURE,
        parentType: ActionTypes.LOAD_SCREEN_VIEW_ASYNC,
        error
    }),

    saveSectionAsync: vo => {
        return (dispatch /*, getState*/) => {
            dispatch({ type: ActionTypes.SAVE_SECTION_ASYNC, vo });

            EditService.saveSection(
                vo,
                response => {
                    dispatch(Actions.saveSectionSuccess(response));
                },
                error => {
                    dispatch(Actions.saveSectionFailure(error));
                }
            );
        };
    },

    saveSectionSuccess: data => ({
        type: ActionTypes.SAVE_SECTION_SUCCESS,
        parentType: ActionTypes.SAVE_SECTION_ASYNC,
        data
    }),

    saveSectionFailure: error => ({
        type: ActionTypes.SAVE_SECTION_FAILURE,
        parentType: ActionTypes.SAVE_SECTION_ASYNC,
        error
    }),

    createSection: courseId => ({
        type: ActionTypes.CREATE_SECTION,
        courseId
    })
};

//
// Initial State
//
const INITIAL_STATE = {
    section: null
};

//
// Reducers
//
const loadScreenViewSuccessPostReducer = (state, { data }) => {
    return { ...state, section: data.section };
};

const createSectionReducer = (state, { courseId }) => {
    return { ...state, section: { courseId } };
};


// Use reduxsauce's createReducer to make it clearer for
// each action handler
const mergedReducer = createReducer(INITIAL_STATE, {
    [ActionTypes.LOAD_SCREEN_VIEW_ASYNC]: AsyncActionReducers.actionReducer,
    [ActionTypes.LOAD_SCREEN_VIEW_SUCCESS]: AsyncActionReducers.successReducer,
    [ActionTypes.LOAD_SCREEN_VIEW_FAILURE]: AsyncActionReducers.failureReducer,
    [ActionTypes.SAVE_SECTION_ASYNC]: AsyncActionReducers.actionReducer,
    [ActionTypes.SAVE_SECTION_SUCCESS]: AsyncActionReducers.successReducer,
    [ActionTypes.SAVE_SECTION_FAILURE]: AsyncActionReducers.failureReducer,
    [ActionTypes.CREATE_SECTION]: createSectionReducer
});

// Enable dynamically register and unregister reducer
const reducer = new ReducerRegister(uid, mergedReducer);

export { ActionTypes, Actions, reducer, INITIAL_STATE };
